import * as yup from 'yup';

export const aiSearchSchema = yup
    .object({
        searchTerm: yup.string().min(1).required('Search term is required!'),
    })
    .required();
